import { c as _c } from "react/compiler-runtime";
import { isEmpty } from 'lodash';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePdpSelectedOptionsVariantSku from 'components/consumer/PDP/state/pdpSelectedOptionsVariantSku/usePdpSelectedOptionsVariantSku';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import useAllProductClearanceStock from '../useAllProductClearanceStock';
const usePDPClearanceData = t0 => {
  const $ = _c(29);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hookOptions = t1;
  const {
    skip: t2,
    defaultValue: t3
  } = hookOptions;
  const skip = t2 === undefined ? false : t2;
  let t4;
  if ($[2] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const defaultValue = t4;
  const {
    loading: clearanceLoading,
    data: clearanceData
  } = useAllProductClearanceStock(skip);
  const {
    loading: basicLoading,
    error: basicError,
    data: basicData
  } = usePDPBasicDetails();
  let t5;
  if ($[4] !== basicData) {
    t5 = basicData || {};
    $[4] = basicData;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const {
    id: productId
  } = t5;
  const {
    loading: optionsLoading,
    error: optionsError
  } = usePDPOptions();
  const selectedOptionsVariantSku = usePdpSelectedOptionsVariantSku();
  let t6;
  if ($[6] !== clearanceData) {
    t6 = isEmpty(clearanceData);
    $[6] = clearanceData;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const isClearanceDataAvailable = !t6;
  let t7;
  if ($[8] !== clearanceData || $[9] !== isClearanceDataAvailable || $[10] !== productId || $[11] !== selectedOptionsVariantSku) {
    t7 = isClearanceDataAvailable ? clearanceData[productId]?.[selectedOptionsVariantSku] : {};
    $[8] = clearanceData;
    $[9] = isClearanceDataAvailable;
    $[10] = productId;
    $[11] = selectedOptionsVariantSku;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const clearanceStockPerSKU = t7;
  let t8;
  if ($[13] !== clearanceStockPerSKU) {
    t8 = isEmpty(clearanceStockPerSKU);
    $[13] = clearanceStockPerSKU;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const isClearance = !t8;
  const isFlashSale = clearanceStockPerSKU?.flashSale;
  const stockCost = isClearance ? parseFloat(clearanceStockPerSKU.stock_cost) : 0;
  let t9;
  if ($[15] !== clearanceData || $[16] !== isClearanceDataAvailable || $[17] !== productId) {
    t9 = isClearanceDataAvailable ? clearanceData[productId] : {};
    $[15] = clearanceData;
    $[16] = isClearanceDataAvailable;
    $[17] = productId;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const optionsClearanceData = t9;
  if (skip) {
    return defaultValue;
  }
  const t10 = clearanceLoading || basicLoading || optionsLoading;
  const t11 = optionsError || basicError;
  let t12;
  if ($[19] !== clearanceStockPerSKU || $[20] !== isClearance || $[21] !== isFlashSale || $[22] !== optionsClearanceData || $[23] !== stockCost) {
    t12 = {
      isClearance,
      isFlashSale,
      stockCost,
      clearanceStockPerSKU,
      optionsClearanceData
    };
    $[19] = clearanceStockPerSKU;
    $[20] = isClearance;
    $[21] = isFlashSale;
    $[22] = optionsClearanceData;
    $[23] = stockCost;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12) {
    t13 = {
      loading: t10,
      error: t11,
      data: t12
    };
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
};
export default usePDPClearanceData;